import { render, staticRenderFns } from "./produce.vue?vue&type=template&id=59b4f93a&scoped=true&"
import script from "./produce.vue?vue&type=script&lang=js&"
export * from "./produce.vue?vue&type=script&lang=js&"
import style0 from "./produce.vue?vue&type=style&index=0&id=59b4f93a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4f93a",
  null
  
)

export default component.exports